export default __webpack_public_path__ + "static/media/settings-icon.2120fcc8.svg";